import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
// import PullToRefresh from 'react-pullable';
import DashboardUI from './DashboardUI';
import Modal from '../common/modals/Modal';
import ResponseHistory from './responce.score/ResponseHistory';
import * as memberSelectors from '../../reducers/member.reducer';
import ContentLoader from '../common/loaders/ContentLoader';
import { dashboardActions, headerActions, appointmentActions, referralActions, taskActions } from 'actions';
import { FILTER_FIELD, HEADER } from '_constants';

import { opportunitiesActions } from '../../actions/opportunities.actions';
import { notificationActions } from '../../actions/notifications.actions';
import { bottomnavActions } from '../../actions/bottomnav.actions';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Dashboard',
  hasBackButton: false,
  hasNotificationIcon: true
};

class Dashboard extends React.Component {
  static propTypes = {
    initialize: PropTypes.func.isRequired,
    getOpportunities: PropTypes.func.isRequired,
    dashboard: PropTypes.object.isRequired,
    getMember: PropTypes.func.isRequired,
    setHeader: PropTypes.func.isRequired,
    memberKey: PropTypes.string.isRequired,
    getNotificationCount: PropTypes.func.isRequired,
    percentage: PropTypes.number.isRequired,
    responseScores: PropTypes.array,
    changeActiveItem: PropTypes.func.isRequired,
    fetchAppointment: PropTypes.func.isRequired,
    changeReferralFilter: PropTypes.func.isRequired,
    fetchReferralsCount: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    outOfOffice: PropTypes.shape({
      startDateTime: PropTypes.string,
      endDateTime: PropTypes.string
    }),
    appointments: PropTypes.array,
    fetchTasks: PropTypes.func.isRequired
  }

  _isMounted = false;

  state = {
    scoreCount: 0,
    isOpen: false,
    firstColor: '#3CB371',
    secondColor: 'forestgreen',
    notificationRoute: true,
    activeReferralsCount: 0,
    closedReferralsCount: 0
  }

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  animateCounter (percentage) {
    const interval = setInterval(() => {
      if (this.state.scoreCount < percentage) {
        this._isMounted && this.setState({ scoreCount: this.state.scoreCount + 1 });
      } else {
        clearInterval(interval);
      }
    }, 10);
    this.contactStrokeValue();
  }

  contactStrokeValue = () => {
    const { percentage } = this.props;

    if (percentage <= 69) {
      this._isMounted && this.setState({ firstColor: '#DC143C' });
      this._isMounted && this.setState({ secondColor: '#B22222' });
    } else if (percentage <= 79) {
      this._isMounted && this.setState({ firstColor: '#FFA500' });
      this._isMounted && this.setState({ secondColor: '#FF8C00' });
    }
  }

  handleBannerRedirect = () => {
    this.props.history.push('/userprofile/outofoffice');
  }

  checkNotificationRoute () {
    const route = localStorage.getItem('notificationRoute');
    if (route) {
      this.setState({ notificationRoute: true });
      this.props.history.push(route);
      localStorage.removeItem('notificationRoute');
    } else {
      this.setState({ notificationRoute: false });
      this.props.setHeader(headerSettings);
    }
  }

  componentDidMount = async () => {
    this.checkNotificationRoute();
    this.initilizeDashboard();
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  pullToRefreshHandler = () => {
    this.initilizeDashboard();
  }

  initilizeDashboard = async () => {
    this.props.changeActiveItem('Dashboard');
    this.props.initialize();
    this.props.getNotificationCount();
    this.props.fetchTasks();
    await this.props.fetchAppointment();
    await this.props.getOpportunities(this.props.memberKey, this.props.appointments);
    const activeReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.ACTIVE_REFERRAL);
    const closedReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.CLOSE_REFERRAL);
    await this.props.getMember(this.props.memberKey);
    this.animateCounter(this.props.percentage);
    await this.setState({
      activeReferralsCount: activeReferralsCount,
      closedReferralsCount: closedReferralsCount
    });
  }

  navigateToReferral = async (filterKey) => {
    this.props.changeReferralFilter(filterKey);
    this.props.history.push('/referrals');
  }

  render () {
    const { outOfOffice } = this.props;
    const startingDate = moment(new Date(outOfOffice.startDateTime));
    const endingDate = moment(new Date(outOfOffice.endDateTime)).subtract(1, 'd');

    const startDate = startingDate.format('MMM') + ' ' + startingDate.format('DD');
    const endDate = endingDate.format('MMM') + ' ' + endingDate.format('DD');

    const today = moment(new Date());
    const dateToCompare = moment(this.props.outOfOffice.startDateTime);
    const isActiveOOO = dateToCompare.startOf('day').isSameOrBefore(today.startOf('day')) && this.props.outOfOffice.startDateTime;

    if (this.state.notificationRoute) {
      return <ContentLoader isLoading />;
    }

    return (
      <React.Fragment>
        <section className='page-content dashboard'>
          <div className='page-content-body dashboard-content-body'>
            {!!isActiveOOO &&
            <div className='ooo-banner-container' onClick={this.handleBannerRedirect}>
              <div className='ooo-banner'> {'You are Out Of Office: '}
                {`${startDate} - ${endDate}`}
              </div>
            </div>
            }
            {/* <PullToRefresh
              onRefresh={this.pullToRefreshHandler}
              spinnerOffset={10}
              spinnerColor='0000FF'
            > */}
            <DashboardUI
              responseScores={this.props.responseScores}
              dashboard={this.props.dashboard}
              scoreCount={this.state.scoreCount}
              activeReferralsCount={this.state.activeReferralsCount}
              closedReferralsCount={this.state.closedReferralsCount}
              toggleModal={this.toggleModal}
              percentage={this.props.percentage}
              firstColor={this.state.firstColor}
              secondColor={this.state.secondColor}
              navigateToReferral={this.navigateToReferral}
            />
            {/* </PullToRefresh> */}
          </div>
          <Modal
            title={'Responsive Score'}
            show={this.state.isOpen}
            onClose={this.toggleModal}
          >
            <ResponseHistory
              percentage={this.props.percentage}
              // dashboard={props.dashboard.percentage}
              responseScores={this.props.responseScores}
              scoreCount={this.state.scoreCount}
            />
          </Modal>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { dashboard, member, userprofile, appointments } = state;
  const responseScore = _.get(memberSelectors.memberData(member), 'memberResponseOMeterScore', '');
  const realScore = (responseScore <= 62) ? 62 : responseScore; // Never display to user a score less than 62
  const percentage = (responseScore < 1) ? 100 : realScore;
  return {
    outOfOffice: _.get(memberSelectors.memberData(member), 'outOfOffice', {}),
    memberKey: _.get(userprofile, 'memberKey', ''),
    responseScores: _.get(member, 'responseScores', []),
    percentage,
    dashboard,
    member,
    appointments: _.get(appointments, 'allAppointments', [])
  };
};

const mapDispatchToProps = dispatch => ({
  initialize: bindActionCreators(dashboardActions.initialize, dispatch),
  getMember: bindActionCreators(dashboardActions.getMember, dispatch),
  getOpportunities: bindActionCreators(opportunitiesActions.getOpportunities, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  getNotificationCount: bindActionCreators(notificationActions.getNotificationCount, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  fetchAppointment: bindActionCreators(appointmentActions.fetch, dispatch),
  changeReferralFilter: bindActionCreators(referralActions.changeReferralFilter, dispatch),
  fetchTasks: bindActionCreators(taskActions.fetchTasks, dispatch),
  fetchReferralsCount: bindActionCreators(referralActions.fetchReferralsCount, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
